<div>
  <ion-header>
    <ion-toolbar color="light">
      <ion-title>Choose a Customer</ion-title>
    </ion-toolbar>
  </ion-header>
  <div class="customer-wrapper">
    <ion-item>
      <ion-label position="floating"></ion-label>
      <ion-select okText="{{'OK'|translate}}" cancelText="{{'CANCEL'|translate}}" aria-label="Customer" (ionChange)="onSelectCustomer($event)">
        <ion-select-option value=null>{{'CUSTOMER.NO'|translate}}</ion-select-option>
        <ion-select-option *ngFor="let customer of customerList" value='{{customer.id}}'>{{customer.name}}</ion-select-option>
      </ion-select>
    </ion-item>
    <div class="customer-buttons">
      <ion-button size="small" (click)="onClickCancel()">{{'CANCEL'|translate}}</ion-button>
      <ion-button size="small" (click)="onClickChoose()">Choose</ion-button>
    </div>
  </div>
</div>
